import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { TransferActionV3 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { CheckboxControl } from 'src/app/form-controls/checkbox/checkbox.control';


interface TransferActionV3FormGroup {
	catheterCheck: FormControl<boolean | null>;
	surgicalSiteCheck: FormControl<boolean | null>;
	medication: FormControl<boolean | null>;
	scheduleAuthorisation: FormControl<boolean | null>;
	updateWardAndKennel: FormControl<boolean | null>;
	updateVisitTeam: FormControl<boolean | null>;
}

@Component({
    selector: 'app-transfer-action-controls-v3',
    templateUrl: './transfer-action-controls-v3.component.html',
    styleUrls: ['../../../common.scss', './transfer-action-controls-v3.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent, CheckboxControl, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferActionControlsComponentV3 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: TransferActionV3;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as TransferActionV3;
	}

	@Input() form!: FormGroup<TransferActionV3FormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit(): void {
		this.form.addControl('catheterCheck', this.formBuilder.control(this.action?.catheterCheck ?? null));
		this.form.addControl('surgicalSiteCheck', this.formBuilder.control(this.action?.surgicalSiteCheck ?? null));
		this.form.addControl('medication', this.formBuilder.control(this.action?.medication ?? null));
		this.form.addControl('scheduleAuthorisation', this.formBuilder.control(this.action?.scheduleAuthorisation ?? null));
		this.form.addControl('updateWardAndKennel', this.formBuilder.control(this.action?.scheduleAuthorisation ?? null));
		this.form.addControl('updateVisitTeam', this.formBuilder.control(this.action?.scheduleAuthorisation ?? null));
	}
}